import { render, staticRenderFns } from "./IbButtonBasic.vue?vue&type=template&id=3b1483a2&scoped=true"
import script from "./IbButtonBasic.vue?vue&type=script&lang=js"
export * from "./IbButtonBasic.vue?vue&type=script&lang=js"
import style0 from "./IbButtonBasic.vue?vue&type=style&index=0&id=3b1483a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1483a2",
  null
  
)

export default component.exports